module.exports = __webpack_public_path__ + "img/ricelog_pinicon_080.742f9b37.png";